import type { TabNavMenuStyleOverrides, TabNavOverrides } from '@withjoy/joykit/components/TabNav';
import { pxToRem } from '@withjoy/joykit/theme';

export const ADMIN_TAB_NAV_OVERRIDES: TabNavOverrides = {
  List: {
    props: {
      borderBottomWidth: 0,
    },
  },
  Link: {
    props: {
      _hover: { color: 'newUIBrandPrimary' },
    },
  },
  MenuTrigger: {
    props: {
      _hover: { color: 'newUIBrandPrimary' },
    },
  },
};

export const ADMIN_MENU_STYLE_OVERRIDES: TabNavMenuStyleOverrides = {
  popoverContent: {
    borderRadius: 4,
    boxShadow: '0 0.4375rem 1.6875rem rgba(44, 41, 37, 0.06), 0 0.25rem 1rem rgba(0, 0, 0, 0.07)',
  },
  popoverBody: {
    minWidth: pxToRem(260),
    maxWidth: pxToRem(320),
    maxHeight: 'calc(100dvh - 8rem)',
    overflow: 'auto',
    padding: 2,
  },
  menuItem: {
    gap: 5,
    paddingY: 2,
    paddingX: 3,
    typographyVariant: 'label2',
    borderRadius: '12px',
    minHeight: '36px',
    _hover: {
      backgroundColor: 'mono2',
      color: 'newUIBrandPrimary',
    },
  },
  menuBadge: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'newUIBrandPrimary',
    border: '1px solid',
    borderColor: 'newUIBrandPrimary',
    padding: '1px 5px',
    fontSize: pxToRem(10),
    lineHeight: 1.4,
    letterSpacing: '-0.032px',
  },
  menuDivider: {
    as: 'hr',
    margin: 3,
    width: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    borderTop: '1px solid',
    borderColor: 'mono3',
    marginY: 3,
  },
};
